import React from 'react';
import { isMobile } from 'react-device-detect';
import './Filters.css';


class Filters extends React.Component {

    constructor(props) {
        super(props);
        this.parameterRef = React.createRef();

    }

    state = {
        isManufacturerFilterOpen: false,
        parameterTitle: 'Select Parameter',
        selectedManufacturer: null,
        manufacturerList: [],
        systemList: [],
        selectedSystem: null,
        filteredProducts: [],
        selectedProduct: null,
        isLimited: 1,
        isMassSpectrometry: 1,
        isLightSensitive: 1,
        secondSet: null,
        isFirstActive: false,
        isFirstSetOpen: false,
        parameterSecondSetTitle: 'Select Parameter',
        thirdSet: null,
        isSecondActive: false,
        isSecondSetOpen: false,
        parameterThirdSetTitle: 'Select Parameter',
        fourthSet: null,
        isThirdActive: false,
        isThirdSetOpen: false,
        parameterFourthSetTitle: 'Select Parameter',
        fifthSet: null,
        isFourthActive: false,
        isFourthSetOpen: false,
        parameterFifthSetTitle: 'Select Parameter',
        sisxthSet: null,
        isFifthActive: false,
        isFifthSetOpen: false,
        parameterSixthSetTitle: 'Select Parameter',
        seventhSet: null,
        isSixthActive: false,
        isSixthSetOpen: false,
        parameterSeventhSetTitle: 'Select Parameter',
        question1: null
    }
    questionParam = {
        question_id: null,
        q_Param_id: null,
        parameter: null,
        question: null

    }
    questionParamArray = [];
    messagesEnd = null;
    // cms_url = "https://find.waters.com/WatersCMS/";
    // cms_url = "http://3.87.231.43:8080/waterscms/";
    //  cms_url = "http://localhost:8085/waterscms/";
      cms_url = "https://find.waters.com/WatersCMS/";

    componentDidMount() {
        setTimeout(() => {
            // console.log(this.parameterRef.current.parentNode, this.parameterRef.current.scrollHeight)
            window.scroll({
                top: this.parameterRef.current.parentNode.offsetTop - this.parameterRef.current.scrollHeight + 50
            })
        }, 200);
        fetch(this.cms_url + "service/bioAdvisor/outcome/app/questionParam/1")
            .then(res => res.json())
            .then(
                (response) => {
                    this.setState({
                        question1: response.result[0].question
                    })
                },
                (error) => {
                    // console.log(error)
                }
            )
            // window.scroll({
            //     top: this.parameterRef.current.parentNode.offsetTop - this.parameterRef.current.scrollHeight + 10,
            //     behavior: 'smooth'
            // })
    }

    render() {

       // const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);
        const openManufacturer = (index) => {


            if (index == 1) {
                this.setState({
                    isManufacturerFilterOpen: !this.state.isManufacturerFilterOpen
                })

                fetch(this.cms_url + "service/bioAdvisor/outcome/app/questionParam/1")
                    .then(res => res.json())
                    .then(
                        (response) => {
                            this.setState({
                                manufacturerList: response.result
                            })
                        },
                        (error) => {
                            // console.log(error)
                        }
                    )
            }
            if (index == 2) {
                this.setState({
                    isFirstSetOpen: !this.state.isFirstSetOpen
                })
            }
            if (index == 3) {
                this.setState({
                    isSecondSetOpen: !this.state.isSecondSetOpen
                })
            }
            if (index == 4) {
                this.setState({
                    isThirdSetOpen: !this.state.isThirdSetOpen
                })
            }
            if (index == 5) {
                this.setState({
                    isFourthSetOpen: !this.state.isFourthSetOpen
                })
            }
            if (index == 6) {
                this.setState({
                    isFifthSetOpen: !this.state.isFifthSetOpen
                })
            }
            if (index == 7) {
                this.setState({
                    isSixthSetOpen: !this.state.isSixthSetOpen
                })
            }
        }
        const scrollToBottom = () => {
            this.messagesEnd.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
            // this.messagesEnd.scrollIntoView({ behavior: "smooth" , block: "start"});
        };
        const scrollToTop = () => {
            window.scroll({
                top: this.parameterRef.current.parentNode.offsetTop - this.parameterRef.current.scrollHeight + 10,
                behavior: 'smooth'
            })
        };
        const selectManufacturer = (parameter, index) => {

            var uri = "";
            this.questionParam.quest_param_comb_id = parameter.quest_param_comb_id;
            this.questionParam.question_id = parameter.question_id;
            this.questionParam.q_Param_id = parameter.q_Param_id;
            this.questionParam.parameter = parameter.parameter;
            this.questionParam.question = parameter.question;
            // console.log(this.questionParamArray.length );
            // console.log(index);
            if (this.questionParamArray.length >= index) {
                // console.log("inside if");
                removeFromFilter({ ...this.questionParam }, index);
            }
            else {
                // console.log("inside else");
                this.questionParamArray.push({ ...this.questionParam });
            }
            if (index == 1) {
                uri = "service/bioAdvisor/outcome/app/nextQuestion/" + index;
                this.setState({
                    parameterTitle: parameter.parameter,
                    selectedManufacturer: parameter.q_Param_id,
                    systemList: [],
                    selectedSystem: null,
                    filteredProducts: [],
                    selectedProduct: null,
                    isLimited: 1,
                    isMassSpectrometry: 1,
                    isLightSensitive: 1
                });

            }
            if (index == 2) {
                uri = "service/bioAdvisor/outcome/app/nextQuestion/" + index;
                this.setState({
                    parameterSecondSetTitle: parameter.parameter
                });

            }
            if (index == 3) {
                scrollToBottom();
                uri = "service/bioAdvisor/outcome/app/nextQuestion/" + index;
                this.setState({
                    parameterThirdSetTitle: parameter.parameter
                });

            }
            if (index == 4) {

                uri = "service/bioAdvisor/outcome/app/nextQuestion/" + index;
                this.setState({
                    parameterFourthSetTitle: parameter.parameter
                });

            }
            if (index == 5) {
                uri = "service/bioAdvisor/outcome/app/nextQuestion/" + index;
                this.setState({
                    parameterFifthSetTitle: parameter.parameter
                });

            }
            if (index == 6) {
                uri = "service/bioAdvisor/outcome/app/nextQuestion/" + index;
                this.setState({
                    parameterSixthSetTitle: parameter.parameter
                });

            }
            if (index == 7) {
                uri = "service/bioAdvisor/outcome/app/nextQuestion/" + index;
                this.setState({
                    parameterSeventhSetTitle: parameter.parameter
                });

            }

            // console.log("parameter=", parameter)
            // console.log("questionParamArray=", ...[this.questionParamArray]);
            setTimeout(() => {
                if (this.state.systemList.length == 0 && this.state.selectedManufacturer != null) {
                    const requestOptions = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(
                            this.questionParamArray
                        )
                    };
                    // console.log(requestOptions);

                    fetch(this.cms_url + uri, requestOptions)
                        .then(res => res.json())
                        .then(
                            (response) => {
                               
                                if (index == 1) {
                                    if (response.resultmsg[0].msgdescription === "params") {
                                        this.setState({
                                            secondSet: response.result,
                                            isFirstActive: true
                                        })
                                    }
                                    if (response.resultmsg[0].msgdescription === "products") {
                                        scrollToTop();
                                        getFilteredProducts(response);
                                    }
                                }
                                if (index == 2) {
                                    if (response.resultmsg[0].msgdescription === "params") {
                                        this.setState({
                                            thirdSet: response.result,
                                            isSecondActive: true
                                        })
                                    }
                                    if (response.resultmsg[0].msgdescription === "products") {
                                        scrollToTop();
                                        getFilteredProducts(response);
                                    }

                                }
                                if (index == 3) {
                                    if (response.resultmsg[0].msgdescription === "params") {
                                        this.setState({
                                            fourthSet: response.result,
                                            isThirdActive: true
                                        })
                                    }
                                    if (response.resultmsg[0].msgdescription === "products") {
                                        scrollToTop();
                                        getFilteredProducts(response);
                                    }
                                }
                                if (index == 4) {
                                    if (response.resultmsg[0].msgdescription === "params") {
                                        this.setState({
                                            fifthSet: response.result,
                                            isFourthActive: true
                                        })
                                    }
                                    if (response.resultmsg[0].msgdescription === "products") {
                                        scrollToTop();
                                        getFilteredProducts(response);
                                    }
                                }
                                if (index == 5) {
                                    if (response.resultmsg[0].msgdescription === "params") {
                                        this.setState({
                                            sixthSet: response.result,
                                            isFifthActive: true
                                        })
                                    }
                                    if (response.resultmsg[0].msgdescription === "products") {
                                        scrollToTop();
                                        getFilteredProducts(response);
                                    }
                                }
                                if (index == 6) {
                                    if (response.resultmsg[0].msgdescription === "params") {
                                        this.setState({
                                            seventhSet: response.result,
                                            isSixthActive: true
                                        })
                                    }
                                    if (response.resultmsg[0].msgdescription === "products") {
                                        scrollToTop();
                                        getFilteredProducts(response);
                                    }
                                }
                                if (index == 7) {

                                    if (response.resultmsg[0].msgdescription === "products") {
                                        scrollToTop();
                                        getFilteredProducts(response);
                                    }
                                }
                            },
                            (error) => {
                                // console.log(error)
                            }
                        )
                }
            }, 100);
        }
        const removeFromFilter = (value, index) => {
            this.questionParamArray[index - 1] = value;
            if (index == 1) {
                this.setState({
                    isSecondActive: false,
                    parameterSecondSetTitle: "Select Parameter",
                    isThirdActive: false,
                    parameterThirdSetTitle: "Select Parameter",
                    isFourthActive: false,
                    parameterFourthSetTitle: "Select Parameter",
                    isFifthActive: false,
                    parameterFifthSetTitle: "Select Parameter",
                    isSixthActive: false,
                    parameterSixthSetTitle: "Select Parameter",
                    isSeventhActive: false,
                    parameterSeventhSetTitle: "Select Parameter",
                });
            }
            if (index == 2) {
                this.setState({
                    isThirdActive: false,
                    parameterThirdSetTitle: "Select Parameter",
                    isFourthActive: false,
                    parameterFourthSetTitle: "Select Parameter",
                    isFifthActive: false,
                    parameterFifthSetTitle: "Select Parameter",
                    isSixthActive: false,
                    parameterSixthSetTitle: "Select Parameter",
                    isSeventhActive: false,
                    parameterSeventhSetTitle: "Select Parameter",
                });
            }
            if (index == 3) {
                this.setState({
                    isFourthActive: false,
                    parameterFourthSetTitle: "Select Parameter",
                    isFifthActive: false,
                    parameterFifthSetTitle: "Select Parameter",
                    isSixthActive: false,
                    parameterSixthSetTitle: "Select Parameter",
                    isSeventhActive: false,
                    parameterSeventhSetTitle: "Select Parameter",
                });
            }
            if (index == 4) {
                this.setState({
                    isFifthActive: false,
                    parameterFifthSetTitle: "Select Parameter",
                    isSixthActive: false,
                    parameterSixthSetTitle: "Select Parameter",
                    isSeventhActive: false,
                    parameterSeventhSetTitle: "Select Parameter",
                });
            }
            if (index == 5) {
                this.setState({
                    isSixthActive: false,
                    parameterSixthSetTitle: "Select Parameter",
                    isSeventhActive: false,
                    parameterSeventhSetTitle: "Select Parameter",
                });
            }
            if (index == 6) {
                this.setState({
                    isSeventhActive: false,
                    parameterSeventhSetTitle: "Select Parameter",
                });
            }
            this.questionParamArray.splice(index, this.questionParamArray.length - 1)
        }
        const selectSystem = (system) => {
            this.setState({
                selectedSystem: system.system_id,
                filteredProducts: [],
                selectedProduct: null,
                isLimited: 1,
                isMassSpectrometry: 1,
                isLightSensitive: 1
            });
            filterProducts();
            if (isMobile) {

                setTimeout(() => {
                    // console.log(this.parameterRef.current.parentNode, this.parameterRef.current.scrollHeight)
                    window.scroll({
                        top: this.parameterRef.current.parentNode.offsetTop - this.parameterRef.current.scrollHeight + 240
                    })
                }, 200);
            }
        }

        const changeParameter1 = (param) => {
            this.setState({
                isLimited: param
            });
            filterProducts();
        }

        const changeParameter2 = (param) => {
            this.setState({
                isMassSpectrometry: param
            });
            filterProducts();
        }

        const changeParameter3 = (param) => {
            this.setState({
                isLightSensitive: param
            });
            filterProducts();
        }

        const filterProducts = () => {
            setTimeout(() => {
                fetch(this.cms_url + "service/vials/app/filter/" + this.state.selectedManufacturer + '/' + this.state.selectedSystem + '/' + this.state.isLimited + '/' + this.state.isMassSpectrometry + '/' + this.state.isLightSensitive)
                    .then(res => res.json())
                    .then(
                        (response) => {

                            if (response != null && response.result != null && response.result.length > 0) {
                                this.setState({
                                    filteredProducts: response.result,
                                    selectedProduct: response.result[0]
                                })
                            } else {
                                this.setState({
                                    filteredProducts: [],
                                    selectedProduct: null
                                })
                            }
                        },
                        (error) => {
                            // console.log(error)
                        }
                    )
            }, 100);
        }

        const selectProduct = (prdId) => {
            for (let i = 0; i < this.state.filteredProducts.length; i++) {
                if (this.state.filteredProducts[i].id == prdId) {
                    this.setState({
                        selectedProduct: this.state.filteredProducts[i]
                    })
                    break;
                } else {
                    this.setState({
                        selectedProduct: null
                    })
                }
            }
        }
        const getFilteredProducts = (response) => {
           
            var prodArray= [];
            response.result.filter(m=>{
                var obj=m;
                if(!(m.url.includes("https") || m.url.includes("http"))){
                    obj.url="//"+m.url;
                }
                if(!(m.image.includes("https") || m.image.includes("http"))){
                    obj.url="//"+m.image;
                }
                prodArray.push(obj);
            })
            this.setState({
                filteredProducts: prodArray,
                selectedProduct: prodArray[0]
            })
        }
        return (
            <div className="row" ref={this.parameterRef}>
                <div className="col-xs-12 col-sm-4 col-md-4">
                    <div className=" sidebar sidebar-cls" >
                        <div className="box" >
                            <p className="primary-clr">{this.state.question1}</p>
                            <ul className="listview"  id="manufacturer" onClick={() => openManufacturer(1)}> <span dangerouslySetInnerHTML={{__html: `${this.state.parameterTitle}`}}></span>
                                {this.state.manufacturerList.map((value, index) => {
                                    return <li className={this.state.isManufacturerFilterOpen ? 'listview__el show' : 'listview__el'} key={index} >
                                        <a className="listview__link" dangerouslySetInnerHTML={{__html: `${value.parameter}`}} onClick={() => selectManufacturer(value, 1)}></a>
                                    </li>
                                })}
                            </ul>
                        </div>

                        {this.state.isFirstActive ? (
                            <div className="box"  >
                                <p className="primary-clr">{this.state.secondSet[0].question} </p>
                                <ul className="listview"  id="manufacturer" onClick={() => openManufacturer(2)}><span dangerouslySetInnerHTML={{__html: `${this.state.parameterSecondSetTitle}`}}></span>
                                    {this.state.secondSet.map((value, index) => {
                                        return <li className={this.state.isFirstSetOpen ? 'listview__el show' : 'listview__el'} key={index} >
                                            <a className="listview__link" dangerouslySetInnerHTML={{__html: `${value.parameter}`}} onClick={() => selectManufacturer(value, 2)}></a>
                                        </li>
                                    })}
                                </ul>
                            </div>
                        ) : ('')}
                        {this.state.isSecondActive ? (
                            <div className="box" >
                                <p className="primary-clr">{this.state.thirdSet[0].question} </p>
                                <ul className="listview" id="manufacturer" onClick={() => openManufacturer(3)}><span dangerouslySetInnerHTML={{__html: `${this.state.parameterThirdSetTitle}`}}></span>
                                    {this.state.thirdSet.map((value, index) => {
                                        return <li className={this.state.isSecondSetOpen ? 'listview__el show' : 'listview__el'} key={index} ref={(el) => { this.messagesEnd = el; }}>
                                            <a className="listview__link" onClick={() => selectManufacturer(value, 3)} dangerouslySetInnerHTML={{__html: `${value.parameter}`}}></a>
                                        </li>
                                    })}
                                </ul>
                            </div>
                        ) : ('')}
                        {this.state.isThirdActive ? (
                            <div className="box">
                                <p className="primary-clr">{this.state.fourthSet[0].question}</p>
                                <ul className="listview" id="manufacturer" onClick={() => openManufacturer(4)}><span dangerouslySetInnerHTML={{__html: `${this.state.parameterFourthSetTitle}`}}></span>
                                    {this.state.fourthSet.map((value, index) => {
                                        return <li className={this.state.isThirdSetOpen ? 'listview__el show' : 'listview__el'} key={index}  >
                                            <a className="listview__link" onClick={() => selectManufacturer(value, 4)} dangerouslySetInnerHTML={{__html: `${value.parameter}`}}></a>
                                        </li>
                                    })}
                                </ul>
                            </div>
                        ) : ('')}
                        {this.state.isFourthActive ? (
                            <div className="box" >
                                <p className="primary-clr">{this.state.fifthSet[0].question}</p>
                                <ul className="listview"  id="manufacturer" onClick={() => openManufacturer(5)}><span dangerouslySetInnerHTML={{__html: `${this.state.parameterFifthSetTitle}`}}></span>
                                    {this.state.fifthSet.map((value, index) => {
                                        return <li className={this.state.isFourthSetOpen ? 'listview__el show' : 'listview__el'} key={index} >
                                            <a className="listview__link" onClick={() => selectManufacturer(value, 5)} dangerouslySetInnerHTML={{__html: `${value.parameter}`}}></a>
                                        </li>
                                    })}
                                </ul>
                            </div>
                        ) : ('')}
                        {this.state.isFifthActive ? (
                            <div className="box" >
                                <p className="primary-clr">{this.state.sixthSet[0].question}</p>
                                <ul className="listview"  id="manufacturer" onClick={() => openManufacturer(6)}> <span dangerouslySetInnerHTML={{__html: `${this.state.parameterSixthSetTitle}`}}></span>
                                    {this.state.sixthSet.map((value, index) => {
                                        return <li className={this.state.isFifthSetOpen ? 'listview__el show' : 'listview__el'} key={index}  >
                                            <a className="listview__link" onClick={() => selectManufacturer(value, 6)} dangerouslySetInnerHTML={{__html: `${value.parameter}`}}></a>
                                        </li>
                                    })}
                                </ul>
                            </div>
                        ) : ('')}
                        {this.state.isSixthActive ? (
                            <div className="box">
                                <p className="primary-clr">{this.state.seventhSet[0].question}</p>
                                <ul className="listview"  id="manufacturer" onClick={() => openManufacturer(7)}> <span dangerouslySetInnerHTML={{__html: `${this.state.parameterSeventhSetTitle}`}}></span>
                                    {this.state.seventhSet.map((value, index) => {
                                        return <li className={this.state.isSixthSetOpen ? 'listview__el show' : 'listview__el'} key={index}>
                                            <a className="listview__link" onClick={() => selectManufacturer(value, 7)} dangerouslySetInnerHTML={{__html: `${value.parameter}`}}></a>
                                        </li>
                                    })}
                                </ul>
                            </div>
                        ) : ('')}

                    </div>
                </div>
                <div className="content-wrapper col-xs-12 col-sm-8 col-md-8"  >

                    {(this.state.selectedProduct != null) ? (
                        <div className={'products-wrapper col-sm-12 ' + (this.state.filteredProducts.length == 0 ? 'hide' : '')} >
                            {this.state.filteredProducts.map((value, index) => {
                                return <div className={"col-sm-4 " + (this.state.selectedProduct.id == value.id ? 'active' : 'inactive') + (isMobile ? ' mt-10' : '')
                                    + (this.state.filteredProducts.length == 1 ? ' wd-100' : '')
                                    + (this.state.filteredProducts.length == 2 ? ' wd-50' : '')
                                    + (this.state.filteredProducts.length == 3 ? ' wd-33' : '')
                                    + (index == 0 ? ' no-pd-l' : '')} onClick={() => selectProduct(value.id)} key={index} >
                                    <div className="card text-centered full-height">
                                        <span className="product-text" >{index == 0 ? 'Recommended choice' : 'Alternate choice'}</span>
                                        <div className="productImg">
                                            <img src={value.image} />
                                        </div>
                                        <span className="partNumber">{value.product_number}</span>
                                        <a href={value.url} className={"color-pg color-pg-primary full-width" + (this.state.selectedProduct.id == value.id ? '' : 'hide')} target="_blank">
                                        Go to Product Page
                                    </a>
                                    </div>
                                </div>
                            })}
                        </div>
                    ) : ('')}
                    {this.state.selectedProduct != null ? (
                        <div className={"col-sm-12 " + (this.state.selectedProduct == null ? 'hide' : '')}>
                            <div className="product-details-container">
                                <h4 className="product-name">{this.state.selectedProduct.title}</h4>
                                <br />
                                <div className="col-sm-12 fs14 no-padd" dangerouslySetInnerHTML={{ __html: `${this.state.selectedProduct.description}` }}></div>
                                <br />
                                {/* <span className="text-bold fs14">Detailed specs:</span><br />
                                <br />
                                <table className="full-width fs14">
                                    <tbody>
                                        <tr>
                                            <td>Certification</td>
                                            <td>{this.state.selectedProduct.certification}</td>
                                        </tr>
                                        <tr>
                                            <td>Type</td>
                                            <td>{this.state.selectedProduct.type}</td>
                                        </tr>
                                        <tr>
                                            <td>Cap</td>
                                            <td>{this.state.selectedProduct.cap}</td>
                                        </tr>
                                        <tr>
                                            <td>Septum</td>
                                            <td>{this.state.selectedProduct.septum}</td>
                                        </tr>
                                        <tr>
                                            <td>Material</td>
                                            <td>{this.state.selectedProduct.material}</td>
                                        </tr>
                                        <tr>
                                            <td>Maximum Injection Volume</td>
                                            <td>{this.state.selectedProduct.maximum_injection_volume}</td>
                                        </tr>
                                        <tr>
                                            <td>Residual Volume</td>
                                            <td>{this.state.selectedProduct.residual_volume}</td>
                                        </tr>
                                    </tbody>
                                </table> */}
                            </div>
                        </div>
                    ) : (<div className="placeholderp">
                        <p>
                        Simplify the process of choosing the best chemistry solutions for your application with the Waters
                        BioAdvisor, which enables you to select an appropriate UPLC/UHPLC or HPLC column and/or 
                        chemistry consumable for a desired application, all organized by molecule type. 

                       </p>
                        <br />
                        <p>
                        Start by choosing your desired biomolecule class from the drop down. The BioAdvisor will walk you 
                        through a quick series of questions to help guide you to the recommended product(s) that address 
                        your need. From there, you can easily learn more from the product description and the link to the 
                        product SKU page, which has further information and purchasing details.
                       </p>
                        <p>
                        Please visit <a className="discAnchor" href="https://www.waters.com/biosep" target="_blank">www.waters.com/biosep</a> for more information on our comprehensive collection of 
                        bioseparations related columns, standards, kits, and reagents.
                       </p>
                        <br />
                    </div>

                        )}
                </div>
            </div>
        );
    }
}

export default Filters;